import {
  CreateCreditTypeResponseSchema,
  type CreateCreditTypeRequestPayload,
  type CreateCreditTypeResponse,
} from '@vy/api-definition';
import { useMutation, useQueryClient, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateProductsQueries } from '../../utils/query-invalidation';

export function useCreateCreditType(
  options?: UseMutationOptions<CreateCreditTypeResponse, unknown, CreateCreditTypeRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (createCreditTypeRequest: CreateCreditTypeRequestPayload) => {
      const api = getPrivateApi();
      const response = await api.createCreditType({ createCreditTypeRequest });
      return CreateCreditTypeResponseSchema.parse(response);
    },
    onSuccess: async () => {
      await invalidateProductsQueries(queryClient);
    },
    ...options,
  });
}
